import moment from 'moment';

const asMoment = (time) => (time === null || time === undefined ? null : moment.isMoment(time) ? time : moment.unix(time));

/** A time as unix seconds, from unix seconds or a moment; null for none. */
export const unixTime = (time) => {
	const at = asMoment(time);
	return at ? at.unix() : null;
};

/** "All day", "10:00 AM", or "10:00 AM – 11:00 AM": when on its day a calendar event is. */
export const eventTimeLabel = (event) => {
	const start = asMoment(event.start_time);
	if(event.all_day || !start) {
		return 'All day';
	}
	const end = asMoment(event.end_time);
	if(!end || end.isSame(start)) {
		return start.format('LT');
	}
	return `${start.format('LT')} – ${end.format(end.isSame(start, 'day') ? 'LT' : 'MMM D, LT')}`;
};

/**
 * The form's fields for an event, or for a new one: an hour from 9 o'clock unless it is all day.
 * Times are "HH:mm", what an <input type=time> holds.
 */
export const eventFormFields = (event = null) => {
	const start = event ? asMoment(event.start_time) : null;
	const end = event ? asMoment(event.end_time) : null;
	const timed = !!event && !event.all_day && !!start;
	return {
		name: event ? event.name || '' : '',
		description: event ? event.description || '' : '',
		allDay: !timed,
		start: timed ? start.format('HH:mm') : '09:00',
		end: timed && end ? end.format('HH:mm') : timed ? start.clone().add(1, 'hour').format('HH:mm') : '10:00',
	};
};

/**
 * What saving the form on `date` sends: start and end as unix timestamps, an all-day event running from
 * midnight to 23:59: `{ event }`, or `{ error }` when the form cannot be saved as it is.
 */
export const eventFromForm = (date, fields) => {
	const name = fields.name.trim();
	if(!name) {
		return { error: 'Give the event a name.' };
	}
	if(!fields.allDay && !(/^\d\d:\d\d$/.test(fields.start) && /^\d\d:\d\d$/.test(fields.end))) {
		return { error: 'Give it a start and an end time.' };
	}
	const at = (time) => {
		const [hour, minute] = time.split(':').map(Number);
		return date.clone().startOf('day').hour(hour).minute(minute);
	};
	const start = fields.allDay ? date.clone().startOf('day') : at(fields.start);
	const end = fields.allDay ? date.clone().startOf('day').hour(23).minute(59) : at(fields.end);
	if(!fields.allDay && end.isBefore(start)) {
		return { error: 'It ends before it starts.' };
	}
	return {
		event: {
			name,
			description: fields.description.trim(),
			all_day: fields.allDay,
			start_time: start.unix(),
			end_time: end.unix(),
		},
	};
};
